import styled from 'styled-components';

import promoColors from '../../../theme/promoColors';

export const FeeTable = styled.div`
    margin: 0 16px;
    opacity: ${(props) => (props.isLock ? '0.3' : null)};
    pointer-events: ${(props) => (props.isLock ? 'none' : null)};
    filter: ${(props) => (props.isLock ? 'blur(1px)' : null)};
`;
export const FeeTableRow = styled.a`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    white-space: nowrap;
    cursor: ${(props) => (props.cursorPointer ? 'pointer' : null)};
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }

    &[tabindex] {
        &:focus-visible {
            background-color: ${promoColors.gray5};
            outline: 1px dashed ${promoColors.gray80};
        }
    }
`;
export const FeeTableSeparator = styled.div`
    align-self: unset;
    flex-grow: 1;
    background-color: ${promoColors.gray20};
    height: 1px;
    margin-bottom: 5px;
    margin-left: 8px;
    margin-right: 8px;
`;
export const FeeTableRightBlock = styled.div`
    display: flex;
    align-items: center;
`;
